import React from 'react'
import '../styles/index.scss'
import ItemErrorPage from "./ItemErrorPage"

function ItemsErrorContainer() {
    return (
        <div className="ItemsErrorContainer">
            <ItemErrorPage/>
        </div>
    )
}

export default ItemsErrorContainer